const DFundedCore = require('../../_common/base/dfunded/core');
const dynamicConfig = require('../../config/dynamic-config');

/**
 * Whether the header shows the DFunded login button (and its modal).
 * Two site switches hide it:
 * - features.dfunded: DFunded is not offered and any session is ignored;
 * - dfundedLoginButton: false: only the button is hidden; a trader already
 *   signed in to DFunded keeps the session and keeps trading.
 * Never throws: on any error the button is shown.
 * @returns {boolean}
 */
const isDFundedLoginButtonVisible = () => {
    try {
        return DFundedCore.isDFundedOfferedOnSite() !== false
            && dynamicConfig.isDFundedLoginButtonShown() !== false;
    } catch (error) {
        return true;
    }
};

module.exports = { isDFundedLoginButtonVisible };
